import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";

export default function CreateAdminModal({ onClose }) {
  const [selectedChallenge, setSelectedChallenge] = useState("");
  const [data, setData] = useState({
    fn: null,
    ln: null,
    email: null,
    phone_number: null,
    password: null,
    password_again: null,
  });
  const isValidEmail = (email) => {
    if (!email) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const isValidPersianPhone = (phone) => {
    if (!phone) return true;
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";

    // convert Persian digits → English
    const english = phone.replace(/[۰-۹]/g, (d) => persianDigits.indexOf(d));

    // must match: 09XXXXXXXXX (11 digits)
    return /^09\d{9}$/.test(english);
  };
  function isValidPassword(password) {
    if (!password) return true;
    // must be at least 8 characters and contain at least:
    // one lowercase letter, one uppercase letter, one number, one special character
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    return regex.test(password);
  }

  const [validation, setValidation] = useState({
    email: true,
    phone_number: true,
    password: true,
    password_again: true,
  });

  useEffect(() => {
    if (!isValidEmail(data.email)) {
      setValidation((pre) => ({ ...pre, email: false }));
    } else {
      setValidation((pre) => ({ ...pre, email: true }));
    }
    if (!isValidPersianPhone(data.phone_number)) {
      setValidation((pre) => ({ ...pre, phone_number: false }));
    } else {
      setValidation((pre) => ({ ...pre, phone_number: true }));
    }
    if (!isValidPassword(data.password)) {
      setValidation((pre) => ({ ...pre, password: false }));
    } else {
      setValidation((pre) => ({ ...pre, password: true }));
    }
    if (data.password_again && data.password_again !== data.password) {
      setValidation((pre) => ({ ...pre, password_again: false }));
    } else {
      setValidation((pre) => ({ ...pre, password_again: true }));
    }
  }, [data]);

  const handleAdd = async () => {
    if (
      !validation.email ||
      !validation.password ||
      !validation.password_again ||
      !validation.phone_number
    ) {
      return;
    }
    const jsonBody = {
      fn: data.fn,
      ln: data.ln,
      email: data.email,
      phone_number: data.phone_number,
      password: data.password,
    };
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/manager/signup/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify(jsonBody),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/manager/signup/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify(jsonBody),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        {/* <InputAdmin label="نقش مدیریتی" id="type" name="type" type="select" selectOptions={["ادمین پشتیبانی", "ادمین مالی"]} selectPlaceHolder="انتخاب کنید"/>
        <InputAdmin label="وضعیت حساب" id="type" name="type" type="select" selectOptions={["فعال", "غیر فعال"]} selectPlaceHolder="انتخاب کنید"/> */}
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="نام"
          id="type"
          name="type"
          type="text"
          value={data.fn}
          onChange={(e) => setData((pre) => ({ ...pre, fn: e.target.value }))}
        />
        <InputAdmin
          label="نام خانوادگی"
          id="type"
          name="type"
          type="text"
          value={data.ln}
          onChange={(e) => setData((pre) => ({ ...pre, ln: e.target.value }))}
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="آدرس ایمیل"
          id="type"
          name="type"
          type="email"
          value={data.email}
          onChange={(e) =>
            setData((pre) => ({ ...pre, email: e.target.value }))
          }
        />
        <InputAdmin
          label="شماره تلفن همراه"
          id="type"
          name="type"
          type="tel"
          value={data.phone_number}
          onChange={(e) =>
            setData((pre) => ({ ...pre, phone_number: e.target.value }))
          }
        />
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="رمز عبور"
          id="type"
          name="type"
          type="password"
          value={data.password}
          onChange={(e) =>
            setData((pre) => ({ ...pre, password: e.target.value }))
          }
        />
        <InputAdmin
          label="تکرار رمز عبور"
          id="type"
          name="type"
          type="password"
          value={data.password_again}
          onChange={(e) =>
            setData((pre) => ({ ...pre, password_again: e.target.value }))
          }
        />
        {/* <div className="w-full"></div> */}
      </div>
      {!validation.email && (
        <p className="text-red-500 text-sm">ایمیل وارد شده صحیح نمی باشد</p>
      )}
      {!validation.phone_number && (
        <p className="text-red-500 text-sm">
          شماره موبایل وارد شده صحیح نمی باشد
        </p>
      )}
      {!validation.password && (
        <p className="text-red-500 text-sm">
          رمز عبور حداقل ۸ کاراکتر شامل عدد، حروف بزرگ و کوچک، کاراکتر ویژه
        </p>
      )}
      {!validation.password_again && (
        <p className="text-red-500 text-sm">رمزهای عبور مطابقت ندارند</p>
      )}
      <div className="w-full flex gap-2.5 mt-6">
        <Custom
          text="انصراف و بستن"
          svg_name="xMark"
          svgClassName="stroke-zi-text-light dark:stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-light dark:text-zi-text-dark ring-1 ring-zi-border-dark bg-transparent"
          onClick={onClose}
        />
        <Custom
          text="ایجاد ادمین جدید"
          svg_name="checkMark"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 w-full text-zi-text-dark bg-zi-gradient-button-blue"
          textShadow={true}
          svgShadow={true}
          onClick={handleAdd}
        />
      </div>
    </ContainerSimple>
  );
}
